<div class="container-fluid align-items-stretch">
  <!-- .navbar-header contains links seen on xs & sm screens -->
  
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item">
        <ng-template #sidebarToggleTooltip>
          Turn on/off <br> sidebar <br>collapsing
        </ng-template>
        <!-- whether to automatically collapse sidebar on mouseleave. If activated acts more like usual admin templates -->
        <a (click)="toggleSidebar('static')" class="nav-link d-none d-lg-block" [tooltip]="sidebarToggleTooltip" placement="bottom" tabindex="-1">
          <i class="fa fa-bars fa-lg"></i>
        </a>
        <!-- shown on xs & sm screen. collapses and expands navigation -->
        <a (click)="toggleSidebar('collapse')" class="d-lg-none nav-link" href="javascript:void(0)" data-html="true" title="Show/hide<br>sidebar"
          data-placement="bottom" tabindex="-1">
          <span class="rounded rounded-lg bg-gray text-white d-md-none"><i class="fa fa-bars fa-lg"></i></span>
          <i class="fa fa-bars fa-lg d-none d-md-block"></i>
        </a>
      </li>
      <li class="nav-item ml-sm d-none d-md-block"><a class="nav-link" (click)="onRefresh()" tabindex="-1"><i
        class="fa fa-refresh fa-lg"></i></a>
      </li>
    </ul>
    <ul class="nav navbar-nav flex-row" (click)="$event.preventDefault()">
      <li class="nav-item mr-2">
        <div class="form-group" *ngIf='city'>
          <ng-select2 id="city-select" [value]="city" (valueChanged)="onCityChange($event)" name="city" [data]="cities"
            [options]="{theme: 'bootstrap4'}" tabindex="-1"></ng-select2>
        </div>
      </li>
      <li class="nav-item dropdown">
        <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown" tabindex="-1" style="padding: 0.75rem;">
          <span class="thumb-sm avatar float-xs-left">
                    <img class="rounded-circle" src="assets/img/avatar.png" alt="..."> </span> &nbsp;
          <strong>{{userFirstName +' '+ userLastName}}</strong>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" (click)="onLogoutClick()" tabindex="-1"><i class="fa fa-sign-out"></i> &nbsp; Log Out</a>
        </ul>
      </li>
    </ul>

  <!-- this part is hidden for xs screens -->
  <!--<div class="collapse navbar-collapse">

    <ul class="nav navbar-nav float-xs-right" (click)="$event.preventDefault()">
      <li class="nav-item dropdown">
        <a href class="nav-link dropdown-toggle" data-toggle="dropdown">
          <span class="thumb-sm avatar float-xs-left">
                    <img class="rounded-circle" src="assets/img/people/a5.jpg" alt="..."> </span>          &nbsp;
          Philip <strong>Smith</strong>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li><a class="dropdown-item" (click)="onLogoutClick()"><i class="fa fa-sign-out"></i> &nbsp; Log Out</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>-->
</div>
